import Report from '../Objects/report'
import Language from '../Objects/language'
import SortingSchema from '../Objects/sortingSchema'
import GenericSchema from '../Objects/genericSchema'
import GenericSource from '../Objects/genericSource'
import GenericTree from '../Objects/genericTree'
import ElementTemplate from '../Objects/elementTemplate'
import User from '../Objects/user'
import QuickSelect from '../Objects/quickSelect'
import MetaMarker from '../Objects/metaMarker'
import ReportMarker from '../Objects/reportMarker'
import MiscImage from '../Objects/miscImage'
import ReportSchema from '../Objects/reportSchema'
import Client from '../Objects/client'
import OAProject from '../Objects/oaProject'
import OAMarker from '../Objects/oaMarker'
import Language_v2 from '../Objects/language_v2'
import { ReportImage } from '../Objects/newReportObjects/reportImage'
import { ClientV2 } from '../Objects/newReportObjects/client_v2'
import { ReportV2 } from '../Objects/newReportObjects/report_v2'
import { PreambleImage } from '../Objects/newReportObjects/preambleImage'
import { ReportRecommendation } from '../Objects/newReportObjects/reportRecommendation'
import { ReportNarrative } from '../Objects/newReportObjects/reportNarrative'
import { Property } from '../Objects/newReportObjects/property'
const typeMap = {}
let arr = [
  SortingSchema,
  GenericSchema,
  GenericSource,
  GenericTree,
  Language,
  ElementTemplate,
  Report,
  User,
  QuickSelect,
  MetaMarker,
  ReportMarker,
  MiscImage,
  ReportSchema,
  Property,
  Client,
  OAProject,
  OAMarker,
  Language_v2,
  ReportImage,
  ReportV2,
  ClientV2,
  PreambleImage,
  ReportRecommendation,
  ReportNarrative,
  Property
]

arr.forEach((o) => {
  // console.log(o)
  if (o && o.getTypeDir) {
    typeMap[o.getTypeDir()] = o
  }
})

if (typeof window !== 'undefined') window._ms_typeMap = typeMap

// console.log('init typeMap', typeMap)
export default typeMap
